import type { AxiosRequestConfig } from 'axios';
import client from 'api/client';
import type {
    SpouseEducationProfile,
    SpouseLanguageProfile,
    SpouseProfile,
    SpouseWorkExperienceProfile,
} from 'api/models/response/SpouseProfile';

const candidateInfoUrl = (section: string, candidateId?: number) => {
    const hasCandidateId =
        typeof candidateId === 'number' && Number.isFinite(candidateId) && candidateId > 0;

    return hasCandidateId
        ? `/candidate_info/${section}/${candidateId}`
        : `/candidate_info/${section}`;
};

export function getSpouse(candidateId?: number, config?: AxiosRequestConfig) {
    return client.get<SpouseProfile | SpouseProfile[] | null>(
        candidateInfoUrl('Spouse', candidateId),
        config
    );
}

/**
 * Related spouse User row when an active UserRelation exists.
 * Profile V0 `Spouse` omits the spouse's user id (`user_id` is the owner);
 * `SpouseNew` returns the related User with navigable `id`.
 */
export function getSpouseRelatedUser(candidateId?: number, config?: AxiosRequestConfig) {
    return client.get<{ id?: number | null } | null>(
        candidateInfoUrl('SpouseNew', candidateId),
        config
    );
}

export function getSpouseLanguage(candidateId?: number, config?: AxiosRequestConfig) {
    return client.get<SpouseLanguageProfile[] | null>(
        candidateInfoUrl('SpouseLanguage', candidateId),
        config
    );
}

export function getSpouseEducation(candidateId?: number, config?: AxiosRequestConfig) {
    return client.get<SpouseEducationProfile[] | null>(
        candidateInfoUrl('SpouseEducation', candidateId),
        config
    );
}

export function getSpouseWorkExperience(candidateId?: number, config?: AxiosRequestConfig) {
    return client.get<SpouseWorkExperienceProfile[] | null>(
        candidateInfoUrl('SpouseWorkExperience', candidateId),
        config
    );
}
